import { applyCutsToDrawing, calculateCuts } from '@moleculeone/draw';
import { DrawnMol, Mol, Reaction } from '@moleculeone/types';

import { ProductDrawer, SubstrateDrawer } from './getPlainMolDrawers';
import { ReversedSubstratesMap } from './reverseMapping';

export function drawMols(
  productMol: Mol,
  productMap: Reaction['productMap'],
  showDisconnections: boolean,
  showSubstrates: boolean,
  mapToSubstrates: ReversedSubstratesMap,
  alignedSubstrateMols: Mol[],
  drawProduct: ProductDrawer,
  drawSubstrate: SubstrateDrawer
): DrawnMol[] {
  if (!productMol) {
    return [];
  }

  const drawnProductMol = drawProduct(productMol);

  if (showDisconnections) {
    const cuts = calculateCuts(productMol, alignedSubstrateMols, productMap, mapToSubstrates);
    applyCutsToDrawing(drawnProductMol, cuts);
  }

  let drawnSubstrateMols: any = [];

  if (showSubstrates) {
    drawnSubstrateMols = alignedSubstrateMols.map((substrateMol, idx) => {
      return drawSubstrate(substrateMol, idx);
    });
  }

  return [drawnProductMol, ...drawnSubstrateMols];
}
